import { createStore } from '@servicetitan/financing-utils-shared';
import { ComponentType, PropsWithChildren, useState } from 'react';

export interface FinalStepLayoutProps {
    doneButtonText?: string;
}

export interface WorkflowLayouts {
    DefaultLayout: ComponentType<PropsWithChildren>;
    FinalStepLayout: ComponentType<PropsWithChildren<FinalStepLayoutProps>>;
}

function useWorkflowLayouts(initialState: WorkflowLayouts) {
    const [layouts] = useState<WorkflowLayouts>(initialState);
    return layouts;
}

export const WorkflowLayoutsStore = createStore(useWorkflowLayouts);

export type WorkflowLayoutsStoreValue = ReturnType<typeof useWorkflowLayouts>;
